export enum EventName {
  None = '',
  UserLogin = 'user_login',

  // Program
  Carousel = 'carousel',
  Updates = 'updates',

  // Daily Briefing
  ViewSPVDashboard = 'view_spv_dashboard',
  ViewBMDashboard = 'view_bm_dashboard',
  ViewABPMDashboard = 'view_abpm_dashboard',
  ViewGoalSettings = 'view_goal_settings',
  ViewAREPerformanceThisMonth = 'view_are_performance_this_month',
  ViewAREPerformanceHistorical = 'view_are_performance_historical',
  ViewAgentPerformanceThisMonth = 'view_agent_performance_this_month',
  ViewAgentPerformanceHistorical = 'view_agent_performance_historical',

  // Day in Life of SPV
  ViewMaintainAssignment = 'view_maintain_assignment',
  ViewMaintainAssignmentARE = 'view_maintain_assignment_are',
  ViewMaintainARESchedule = 'view_maintain_are_schedule',
  ViewMaintainAREScheduleDetail = 'view_maintain_are_schedule_detail',
  ViewMaintainReport = 'view_maintain_report',
  ViewMaintainReportList = 'view_maintain_report_list',
  ViewMaintainReportDetail = 'view_maintain_report_detail',

  ViewAreaMapping = 'view_area_mapping',
  ViewRecruitmentArea = 'view_recruitment_area',
  ViewRecruitmentAssignmentARE = 'view_recruitment_assignment_are',
  ViewRecruitmentListARE = 'view_recruitment_list_are',
  ViewRecruitmentListAREDetail = 'view_recruitment_list_are_detail',
  ViewRecruitmentReport = 'view_recruitment_report',
  ViewRecruitmentReportARE = 'view_recruitment_report_are',
  ViewRecruitmentReportAREDetail = 'view_recruitment_report_are_detail',

  ViewMaintainNonRegistAssignment = 'view_maintain_non_regist_assignment',
  ViewMaintainNonRegistAssignmentARE = 'view_maintain_non_regist_assignment_are',
  ViewMaintainNonRegistARESchedule = 'view_maintain_non_regist_are_schedule',
  ViewMaintainNonRegistAREScheduleDetail = 'view_maintain_non_regist_are_schedule_detail',

  ViewJoinVisit = 'view_join_visit',
  ViewJoinVisitAREThisMonth = 'view_join_visit_are_this_month',
  ViewJoinVisitAREHistorical = 'view_join_visit_are_historical',

  ViewSPVOneOnOne = 'view_spv_1_on_1',
  ViewSPVOneOnOneSales = 'view_spv_1_on_1_sales',
  ViewSPVOneOnOneRecruit = 'view_spv_1_on_1_recruit',
  ViewSPVOneOnOneMaintain = 'view_spv_1_on_1_maintain',

  ViewAgentManagementActiveARE = 'view_agent_management_active_are',
  ViewAgentManagementActiveSPV = 'view_agent_management_active_spv',
  ViewAgentManagementInactive = 'view_agent_management_inactive',
  ViewAgentManagementBlacklist = 'view_agent_management_blacklist',
  ViewAgentDetailsActive = 'view_agent_details_active',
  ViewAREHierarchy = 'view_are_hierarchy',

  ViewLeadsTrackerReserved = 'view_leads_tracker_reserved',
  ViewLeadsTrackerReservedDetail = 'view_leads_tracker_reserved_detail',
  ViewLeadsTrackerProspect = 'view_leads_tracker_prospect',
  ViewLeadsTrackerProspectDetail = 'view_leads_tracker_prospect_detail',
  ViewLeadsTrackerSurvey = 'view_leads_tracker_survey',
  ViewLeadsTrackerSurveyDetail = 'view_leads_tracker_survey_detail',
  ViewLeadsTrackerGolive = 'view_leads_tracker_go_live',
  ViewLeadsTrackerGoliveDetail = 'view_leads_tracker_go_live_detail',
  ViewLeadsTrackerRejected = 'view_leads_tracker_rejected',
  ViewLeadsTrackerRejectedDetail = 'view_leads_tracker_rejected_detail',

  ViewUserGuideGlossary = 'view_user_guide_glossary',
  ViewUserGuideGuideline = 'view_user_guide_guideline',
  ViewUserGuideTermsUpdate = 'view_user_guide_terms_update',

  SICMaintainAssignmentARE = 'sic_maintain_assignment_are',
  SICMaintainReport = 'sic_maintain_report',
  SICRecruitmentAssignmentARE = 'sic_recruitment_assignment_are',
  SICRecruitmentListARE = 'sic_recruitment_list_are',
  SICRecruitmentReportARE = 'sic_recruitment_report_are',
  SICMaintainNonRegistAssignmentARE = 'sic_maintain_non_regist_assignment_are',
}
